import {
  c2paSigningNotFoundResponseSchema,
  c2paStatusResponseSchema,
  deleteC2paSigningResponseSchema,
  listC2paSigningsResponseSchema,
} from 'xosign-types';
import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

const deleteSigningRequestSchema = z.object({
  signingId: z.string(),
});

const endpoints = {
  'c2pa.status': {
    method: 'GET',
    url: `${API_URL_BASE}c2pa/status`,
    requestSchema: z.undefined(),
    responseSuccessSchema: c2paStatusResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof c2paStatusResponseSchema,
    z.ZodUndefined
  >,
  'c2pa.signings': {
    method: 'GET',
    url: `${API_URL_BASE}c2pa/signings`,
    requestSchema: z.undefined(),
    responseSuccessSchema: listC2paSigningsResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: z.undefined(),
  } satisfies EndpointDefinition<
    z.ZodUndefined,
    typeof listC2paSigningsResponseSchema,
    z.ZodUndefined
  >,
  'c2pa.signings.delete': {
    method: 'DELETE',
    url: `${API_URL_BASE}c2pa/signings/:signingId`,
    requestSchema: deleteSigningRequestSchema,
    responseSuccessSchema: deleteC2paSigningResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      404: c2paSigningNotFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof deleteSigningRequestSchema,
    typeof deleteC2paSigningResponseSchema,
    {
      404: typeof c2paSigningNotFoundResponseSchema;
    }
  >,
};

export default endpoints;
